
import { Component, PropSync } from "vue-property-decorator";
import Vue from "vue";

@Component({})
export default class PopupReport extends Vue {
    @PropSync("show", { type: Boolean, required: true })
    public readonly visible!: boolean;
}
